import React from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import { Container } from '../../components'
import { Content } from './components'
import styles from './register.module.css'

const Register = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderOnlyLayout>
        <Container>
          <Content />
        </Container>
      </HeaderOnlyLayout>
    </div>
  )
}

export { Register }
